export default {
  "pageLanding": [
    {
      "params": {
        "slug": "virtual-training"
      }
    },
    {
      "params": {
        "slug": "home"
      }
    },
    {
      "params": {
        "slug": "self-guided-learning"
      }
    },
    {
      "params": {
        "slug": "page-profile"
      }
    },
    {
      "params": {
        "slug": "nonprofit-courses"
      }
    }
  ],
  "pageCourse": [
    {
      "params": {
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-capture-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-replay-course"
      }
    },
    {
      "params": {
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "slug": "nonprofit-admin-advanced-team-management"
      }
    },
    {
      "params": {
        "slug": "microsoft-co-authoring-for-dropbox-course"
      }
    },
    {
      "params": {
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "slug": "dash-in-dropbox-admins"
      }
    },
    {
      "params": {
        "slug": "dash-in-dropbox-team-members"
      }
    },
    {
      "params": {
        "slug": "dropbox-protect-fundamentals"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "slug": "dropbox-ai-integrations-use-dropbox-with-claude"
      }
    },
    {
      "params": {
        "slug": "dropbox-ai-integrations"
      }
    },
    {
      "params": {
        "slug": "new-dropbox-experience"
      }
    }
  ],
  "pageCourseTopic": [
    {
      "params": {
        "slug": "team-member-what-is-dropbox"
      }
    },
    {
      "params": {
        "slug": "team-member-getting-your-account-set-up"
      }
    },
    {
      "params": {
        "slug": "how-can-i-support-my-teams-users-with-dropbox"
      }
    },
    {
      "params": {
        "slug": "what-tools-are-available-to-me"
      }
    },
    {
      "params": {
        "slug": "common-team-member-challenges"
      }
    },
    {
      "params": {
        "slug": "troubleshooting-shared-file-issues"
      }
    },
    {
      "params": {
        "slug": "troubleshooting-file-update-issues"
      }
    },
    {
      "params": {
        "slug": "troubleshooting-a-shared-link-error"
      }
    },
    {
      "params": {
        "slug": "troubleshooting-accidental-file-deletion"
      }
    },
    {
      "params": {
        "slug": "troubleshooting-storage-space-issues"
      }
    },
    {
      "params": {
        "slug": "team-member-where-and-how-do-i-save-my-stuff"
      }
    },
    {
      "params": {
        "slug": "team-member-how-do-i-share-and-collaborate-with-my-team"
      }
    },
    {
      "params": {
        "slug": "team-member-how-can-dropbox-help-my-team-work-together"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-do-i-use-paper"
      }
    },
    {
      "params": {
        "slug": "fundamentals-what-is-dropbox"
      }
    },
    {
      "params": {
        "slug": "fundamentals-getting-your-account-set-up"
      }
    },
    {
      "params": {
        "slug": "team-member-how-designers-and-creators-use-dropbox"
      }
    },
    {
      "params": {
        "slug": "team-member-how-project-leaders-use-dropbox"
      }
    },
    {
      "params": {
        "slug": "fundamentals-where-and-how-do-i-save-my-stuff"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-do-i-share-with-others"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-can-dropbox-help-me-collaborate-with-others"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-do-i-request-stuff-from-others"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-can-i-get-help"
      }
    },
    {
      "params": {
        "slug": "what-does-it-mean-to-be-an-admin-for-dropbox"
      }
    },
    {
      "params": {
        "slug": "what-can-i-do-through-the-admin-console"
      }
    },
    {
      "params": {
        "slug": "using-dropbox-to-automate-business-processes"
      }
    },
    {
      "params": {
        "slug": "life-of-an-admin-at-a-large-business"
      }
    },
    {
      "params": {
        "slug": "how-do-i-get-started"
      }
    },
    {
      "params": {
        "slug": "how-do-i-control-my-teams-access-to-dropbox"
      }
    },
    {
      "params": {
        "slug": "how-do-i-set-up-admin-access-for-others"
      }
    },
    {
      "params": {
        "slug": "what-can-i-do-to-make-my-teams-account-even-more-secure"
      }
    },
    {
      "params": {
        "slug": "how-do-i-set-team-wide-permissions"
      }
    },
    {
      "params": {
        "slug": "how-to-use-your-shared-team-space-to-manage-your-organizations-content"
      }
    },
    {
      "params": {
        "slug": "using-a-third-party-technology-partner"
      }
    },
    {
      "params": {
        "slug": "integrating-with-your-identity-provider"
      }
    },
    {
      "params": {
        "slug": "connecting-to-our-scripting-community"
      }
    },
    {
      "params": {
        "slug": "life-of-an-admin-at-a-small-business"
      }
    },
    {
      "params": {
        "slug": "how-to-use-dropbox"
      }
    },
    {
      "params": {
        "slug": "dropbox-for-business"
      }
    },
    {
      "params": {
        "slug": "advanced-features-of-the-admin-console"
      }
    },
    {
      "params": {
        "slug": "team-member-how-do-i-use-dropbox-paper"
      }
    },
    {
      "params": {
        "slug": "business-tips-and-tricks"
      }
    },
    {
      "params": {
        "slug": "fundamentals-tips-and-tricks"
      }
    },
    {
      "params": {
        "slug": "dropbox-capture-guide"
      }
    },
    {
      "params": {
        "slug": "dropbox-replay-guide"
      }
    },
    {
      "params": {
        "slug": "nonprofit-team-member-whats-dropbox-for"
      }
    },
    {
      "params": {
        "slug": "nonprofit-admin-whats-dropbox-for"
      }
    },
    {
      "params": {
        "slug": "nonprofit-what-is-dropbox"
      }
    },
    {
      "params": {
        "slug": "nonprofit-team-member-welcome-video"
      }
    },
    {
      "params": {
        "slug": "nonprofit-where-and-how-do-i-save-my-stuff"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-share-with-others"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-can-dropbox-help-me-collaborate-with-others"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-request-stuff-from-others"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-use-dropbox-paper"
      }
    },
    {
      "params": {
        "slug": "nonprofit-dropbox-tips-and-tricks"
      }
    },
    {
      "params": {
        "slug": "nonprofit-dropbox-capture"
      }
    },
    {
      "params": {
        "slug": "nonprofit-dropbox-replay"
      }
    },
    {
      "params": {
        "slug": "nonprofit-drop-in-for-success-webinars"
      }
    },
    {
      "params": {
        "slug": "nonprofit-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "slug": "nonprofit-admin-welcome-videos"
      }
    },
    {
      "params": {
        "slug": "nonprofit-what-can-i-do-through-the-admin-console"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-set-team-wide-permissions"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-control-my-teams-access-to-dropbox"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-manage-my-organizations-data"
      }
    },
    {
      "params": {
        "slug": "nonprofit-how-do-i-set-up-admin-access-for-others"
      }
    },
    {
      "params": {
        "slug": "nonprofit-what-can-i-do-to-make-my-teams-account-even-more-secure"
      }
    },
    {
      "params": {
        "slug": "nonprofit-advanced-features-of-the-admin-console"
      }
    },
    {
      "params": {
        "slug": "nonprofit-admin-interactive-tutorial"
      }
    },
    {
      "params": {
        "slug": "nonprofit-team-member-interactive-tutorial"
      }
    },
    {
      "params": {
        "slug": "test-topic-page"
      }
    },
    {
      "params": {
        "slug": "sh-test"
      }
    },
    {
      "params": {
        "slug": "testaccsample"
      }
    },
    {
      "params": {
        "slug": "microsoft-co-authoring-for-dropbox-guide"
      }
    },
    {
      "params": {
        "slug": "plan-and-configure"
      }
    },
    {
      "params": {
        "slug": "deploy-and-empower-your-team"
      }
    },
    {
      "params": {
        "slug": "manage-and-optimize"
      }
    },
    {
      "params": {
        "slug": "additional-resources"
      }
    },
    {
      "params": {
        "slug": "get-started"
      }
    },
    {
      "params": {
        "slug": "dropbox-admin-guide"
      }
    },
    {
      "params": {
        "slug": "getting-started-as-a-new-admin-for-an-existing-team"
      }
    },
    {
      "params": {
        "slug": "how-a-real-estate-company-uses-dropbox-sign"
      }
    },
    {
      "params": {
        "slug": "account-capture"
      }
    },
    {
      "params": {
        "slug": "dash-team-member-getting-started-guide"
      }
    },
    {
      "params": {
        "slug": "dash-admin-getting-started-guide"
      }
    },
    {
      "params": {
        "slug": "dash-team-member-get-started-with-dash-chat"
      }
    },
    {
      "params": {
        "slug": "connect-and-manage-apps-as-an-admin"
      }
    },
    {
      "params": {
        "slug": "ask-and-write-with-dash"
      }
    },
    {
      "params": {
        "slug": "search-and-find-answers"
      }
    },
    {
      "params": {
        "slug": "connect-and-manage-apps-as-a-team-member"
      }
    },
    {
      "params": {
        "slug": "reclaim-initial-setup"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-set-up-focus-time"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-use-habits"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-enable-calendar-sync"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-use-tasks"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-use-priorities"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-add-buffers-decompression-and-travel-time"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-use-smart-meetings"
      }
    },
    {
      "params": {
        "slug": "reclaim-how-to-set-up-scheduling-links"
      }
    },
    {
      "params": {
        "slug": "reclaim-pilot-resources"
      }
    },
    {
      "params": {
        "slug": "get-more-from-dash-using-the-browser-extension"
      }
    },
    {
      "params": {
        "slug": "how-to-use-dropbox"
      }
    },
    {
      "params": {
        "slug": "dash-for-admins-build-better-workspaces-with-stacks"
      }
    },
    {
      "params": {
        "slug": "build-better-workspaces-with-stacks"
      }
    },
    {
      "params": {
        "slug": "dropbox-desktop-app"
      }
    },
    {
      "params": {
        "slug": "create-and-upload-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "how-to-organize-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "view-and-edit-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-do-i-share-with-others"
      }
    },
    {
      "params": {
        "slug": "delete-and-restore-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "fundamentals-how-do-i-use-paper"
      }
    },
    {
      "params": {
        "slug": "dropbox-mobile-app"
      }
    },
    {
      "params": {
        "slug": "get-started-with-dropbox-protect"
      }
    },
    {
      "params": {
        "slug": "get-to-know-dash-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "get-started-with-dash-in-dropbox"
      }
    },
    {
      "params": {
        "slug": "dash-prompts"
      }
    },
    {
      "params": {
        "slug": "get-started-with-dropbox-sign"
      }
    },
    {
      "params": {
        "slug": "sending-signature-requests"
      }
    },
    {
      "params": {
        "slug": "dropbox-sign-templates"
      }
    },
    {
      "params": {
        "slug": "bulk-send-signature-requests"
      }
    },
    {
      "params": {
        "slug": "secure-signature-requests"
      }
    },
    {
      "params": {
        "slug": "get-started-with-dropbox-sign-admin-console"
      }
    },
    {
      "params": {
        "slug": "manage-users-and-teams"
      }
    },
    {
      "params": {
        "slug": "configure-organization-settings"
      }
    },
    {
      "params": {
        "slug": "security-and-access-controls"
      }
    },
    {
      "params": {
        "slug": "monitor-activity-and-compliance"
      }
    },
    {
      "params": {
        "slug": "advanced-admin-features"
      }
    },
    {
      "params": {
        "slug": "get-started-with-the-dropbox-sign-api"
      }
    },
    {
      "params": {
        "slug": "manage-api-keys"
      }
    },
    {
      "params": {
        "slug": "monitor-api-activity"
      }
    },
    {
      "params": {
        "slug": "manage-api-apps"
      }
    },
    {
      "params": {
        "slug": "manage-callbacks"
      }
    },
    {
      "params": {
        "slug": "production-deployment"
      }
    },
    {
      "params": {
        "slug": "api-administration-best-practices"
      }
    },
    {
      "params": {
        "slug": "tags-tetsing"
      }
    },
    {
      "params": {
        "slug": "get-started-with-dropbox-for-teams"
      }
    },
    {
      "params": {
        "slug": "organize-team-files-and-folders"
      }
    },
    {
      "params": {
        "slug": "share-and-collaborate-with-dropbox"
      }
    },
    {
      "params": {
        "slug": "work-from-anywhere-with-dropbox"
      }
    },
    {
      "params": {
        "slug": "streamline-work-with-dropbox"
      }
    },
    {
      "params": {
        "slug": "use-dropbox-with-claude"
      }
    },
    {
      "params": {
        "slug": "use-dropbox-with-chatgpt"
      }
    },
    {
      "params": {
        "slug": "how-teams-use-dropbox"
      }
    },
    {
      "params": {
        "slug": "get-started-with-new-dropbox-experience"
      }
    },
    {
      "params": {
        "slug": "manage-new-dropbox-experience"
      }
    }
  ],
  "pageCourseTopicsV2": [
    {
      "params": {
        "slug": "sharing-files-and-folders-with-dropbo"
      }
    },
    {
      "params": {
        "slug": "home"
      }
    },
    {
      "params": {
        "slug": "ratnatest"
      }
    },
    {
      "params": {
        "slug": "workflow-testing"
      }
    }
  ],
  "pageVideo": [
    {
      "params": {
        "videoslug": "single-sign-on-sso"
      }
    },
    {
      "params": {
        "videoslug": "file-requests"
      }
    },
    {
      "params": {
        "videoslug": "account-capture-for-team-members"
      }
    },
    {
      "params": {
        "videoslug": "integrated-image-search"
      }
    },
    {
      "params": {
        "videoslug": "how-to-view-activity-log"
      }
    },
    {
      "params": {
        "videoslug": "manage-security-alerts"
      }
    },
    {
      "params": {
        "videoslug": "account-capture-for-admins"
      }
    },
    {
      "params": {
        "videoslug": "what-is-web-session-control"
      }
    },
    {
      "params": {
        "videoslug": "remove-team-member"
      }
    },
    {
      "params": {
        "videoslug": "how-to-set-a-federated-team"
      }
    },
    {
      "params": {
        "videoslug": "send-large-files-with-dropbox-transfer"
      }
    },
    {
      "params": {
        "videoslug": "comments-in-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "enable-two-factor-authentication"
      }
    },
    {
      "params": {
        "videoslug": "manage-dropbox-groups"
      }
    },
    {
      "params": {
        "videoslug": "custom-branding-and-watermarking"
      }
    },
    {
      "params": {
        "videoslug": "understand-file-sharing-options"
      }
    },
    {
      "params": {
        "videoslug": "discover-dropbox-file-requests"
      }
    },
    {
      "params": {
        "videoslug": "discover-dropbox-transfer"
      }
    },
    {
      "params": {
        "videoslug": "team-folders-overview"
      }
    },
    {
      "params": {
        "videoslug": "set-sharing-permissions"
      }
    },
    {
      "params": {
        "videoslug": "manage-team-external-sharing"
      }
    },
    {
      "params": {
        "videoslug": "manage-device-approvals"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-replay-overview"
      }
    },
    {
      "params": {
        "videoslug": "ransomware-respond-to-attacks"
      }
    },
    {
      "params": {
        "videoslug": "activate-ransomware-protection"
      }
    },
    {
      "params": {
        "videoslug": "how-to-use-dropbox-rewind"
      }
    },
    {
      "params": {
        "videoslug": "remove-member-from-legal-hold"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-backup-overview"
      }
    },
    {
      "params": {
        "videoslug": "legal-holds-and-data-governance"
      }
    },
    {
      "params": {
        "videoslug": "data-governance-overview"
      }
    },
    {
      "params": {
        "videoslug": "mxhero-email-links-malware-detection"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-one-login-sso"
      }
    },
    {
      "params": {
        "videoslug": "what-is-the-dropbox-badge"
      }
    },
    {
      "params": {
        "videoslug": "mxhero-secure-email-links"
      }
    },
    {
      "params": {
        "videoslug": "install-sso-dropbox-okta"
      }
    },
    {
      "params": {
        "videoslug": "install-sso-dropbox-microsoft-azure"
      }
    },
    {
      "params": {
        "videoslug": "team-member-welcome-video"
      }
    },
    {
      "params": {
        "videoslug": "admin-welcome-video"
      }
    },
    {
      "params": {
        "videoslug": "how-to-get-started-with-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "sharing-files-and-folders-with-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "restore-deleted-files-and-previous-versions"
      }
    },
    {
      "params": {
        "videoslug": "upload-and-download-files"
      }
    },
    {
      "params": {
        "videoslug": "file-requests-overview"
      }
    },
    {
      "params": {
        "videoslug": "close-a-file-request"
      }
    },
    {
      "params": {
        "videoslug": "share-team-subfolder"
      }
    },
    {
      "params": {
        "videoslug": "admin-console-overview"
      }
    },
    {
      "params": {
        "videoslug": "merge-team-accounts"
      }
    },
    {
      "params": {
        "videoslug": "team-activity-report-overview"
      }
    },
    {
      "params": {
        "videoslug": "enable-early-access-to-dropbox-features"
      }
    },
    {
      "params": {
        "videoslug": "install-dropbox-ad-connector"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-domain-verification"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-team-space-overview"
      }
    },
    {
      "params": {
        "videoslug": "create-manage-team-folder"
      }
    },
    {
      "params": {
        "videoslug": "legal-hold-overview"
      }
    },
    {
      "params": {
        "videoslug": "scan-docs-to-your-account"
      }
    },
    {
      "params": {
        "videoslug": "get-started-with-paper"
      }
    },
    {
      "params": {
        "videoslug": "organize-work-with-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "how-to-create-a-har-file"
      }
    },
    {
      "params": {
        "videoslug": "test-or-accordion-lorem-ipsum"
      }
    },
    {
      "params": {
        "videoslug": "test-or-savannas-test-video-page"
      }
    },
    {
      "params": {
        "videoslug": "create-team-folders-admin-console"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-overview"
      }
    },
    {
      "params": {
        "videoslug": "top-3-features-for-aec-professionals"
      }
    },
    {
      "params": {
        "videoslug": "enable-two-factor-authentication-individual"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-connect-apps-admin"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-connect-apps"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-ask-and-write"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-search"
      }
    },
    {
      "params": {
        "videoslug": "welcome-to-dash-in-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "welcome-to-dash-in-dropbox-admin"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-team-member-training"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-admin-training"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-fundamentals-training"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-sign-training"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-admin-training"
      }
    },
    {
      "params": {
        "videoslug": "delete-files-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "what-is-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-or-overview-or-untitled"
      }
    },
    {
      "params": {
        "videoslug": "install-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-camera-uploads"
      }
    },
    {
      "params": {
        "videoslug": "key-features-in-dash"
      }
    },
    {
      "params": {
        "videoslug": "organize-projects-with-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "add-content-to-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "build-stacks-from-search-dash"
      }
    },
    {
      "params": {
        "videoslug": "organize-customize-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "summarize-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "onboard-team-with-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "share-stacks-dash"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-dash-full-demo"
      }
    },
    {
      "params": {
        "videoslug": "connect-apps-for-search-dash"
      }
    },
    {
      "params": {
        "videoslug": "search-across-tools-dash"
      }
    },
    {
      "params": {
        "videoslug": "visual-search-images-dash"
      }
    },
    {
      "params": {
        "videoslug": "verify-files-dash"
      }
    },
    {
      "params": {
        "videoslug": "track-document-changes-dash"
      }
    },
    {
      "params": {
        "videoslug": "keep-project-context-connected-dash"
      }
    },
    {
      "params": {
        "videoslug": "how-secure-is-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "make-dropbox-files-available-offline"
      }
    },
    {
      "params": {
        "videoslug": "connect-apps-in-dash"
      }
    },
    {
      "params": {
        "videoslug": "summarize-documents-dash"
      }
    },
    {
      "params": {
        "videoslug": "ask-questions-documents-dash"
      }
    },
    {
      "params": {
        "videoslug": "generate-content-dash"
      }
    },
    {
      "params": {
        "videoslug": "adjust-writing-tone-dash"
      }
    },
    {
      "params": {
        "videoslug": "update-dropbox-email-password"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-storage-usage"
      }
    },
    {
      "params": {
        "videoslug": "dropbox-online-only-files"
      }
    },
    {
      "params": {
        "videoslug": "sharing-files-and-folders-in-dropbox"
      }
    },
    {
      "params": {
        "videoslug": "create-onboarding-stack-dash"
      }
    },
    {
      "params": {
        "videoslug": "find-onboarding-information-dash"
      }
    },
    {
      "params": {
        "videoslug": "how-to-use-the-dropbox-mobile-app"
      }
    },
    {
      "params": {
        "videoslug": "what-is-dropbox-sign"
      }
    },
    {
      "params": {
        "videoslug": "how-dropbox-storage-works"
      }
    },
    {
      "params": {
        "videoslug": "send-signature-request-dropbox-sign"
      }
    },
    {
      "params": {
        "videoslug": "add-dropbox-to-file-explorer"
      }
    }
  ],
  "pageVideoLanding": [
    {
      "params": {
        "slug": "video-library"
      }
    }
  ],
  "pageCourseTopicNested": [
    {
      "params": {
        "topicslug": "dropbox-admin-guide",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "getting-started-as-a-new-admin-for-an-existing-team",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "what-does-it-mean-to-be-an-admin-for-dropbox",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "what-can-i-do-through-the-admin-console",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "how-do-i-get-started",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "account-capture",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "how-do-i-set-up-admin-access-for-others",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "how-do-i-set-team-wide-permissions",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "what-can-i-do-to-make-my-teams-account-even-more-secure",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "how-to-use-your-shared-team-space-to-manage-your-organizations-content",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "how-do-i-control-my-teams-access-to-dropbox",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "integrating-with-your-identity-provider",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "advanced-features-of-the-admin-console",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "using-a-third-party-technology-partner",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "connecting-to-our-scripting-community",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "using-dropbox-to-automate-business-processes",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "life-of-an-admin-at-a-small-business",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "life-of-an-admin-at-a-large-business",
        "slug": "business-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-dropbox-for-teams",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "organize-team-files-and-folders",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "share-and-collaborate-with-dropbox",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "work-from-anywhere-with-dropbox",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "streamline-work-with-dropbox",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "how-teams-use-dropbox",
        "slug": "business-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "how-to-use-dropbox",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "dropbox-desktop-app",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "create-and-upload-in-dropbox",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "how-to-organize-in-dropbox",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "view-and-edit-in-dropbox",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "fundamentals-how-do-i-share-with-others",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "delete-and-restore-in-dropbox",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "dropbox-mobile-app",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "fundamentals-how-do-i-use-paper",
        "slug": "dropbox-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "how-can-i-support-my-teams-users-with-dropbox",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "what-tools-are-available-to-me",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "common-team-member-challenges",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "troubleshooting-shared-file-issues",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "troubleshooting-file-update-issues",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "troubleshooting-a-shared-link-error",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "troubleshooting-accidental-file-deletion",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "troubleshooting-storage-space-issues",
        "slug": "help-desk-course"
      }
    },
    {
      "params": {
        "topicslug": "dropbox-capture-guide",
        "slug": "dropbox-capture-course"
      }
    },
    {
      "params": {
        "topicslug": "dropbox-replay-guide",
        "slug": "dropbox-replay-course"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-team-member-whats-dropbox-for",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-what-is-dropbox",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-team-member-welcome-video",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-where-and-how-do-i-save-my-stuff",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-share-with-others",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-can-dropbox-help-me-collaborate-with-others",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-team-member-interactive-tutorial",
        "slug": "nonprofit-team-member-getting-started"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-request-stuff-from-others",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-use-dropbox-paper",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-dropbox-tips-and-tricks",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-dropbox-capture",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-dropbox-replay",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-drop-in-for-success-webinars",
        "slug": "nonprofit-team-member-get-more-from-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-admin-whats-dropbox-for",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-getting-your-team-on-dropbox",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-admin-welcome-videos",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-what-can-i-do-through-the-admin-console",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-set-team-wide-permissions",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-manage-my-organizations-data",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-control-my-teams-access-to-dropbox",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-admin-interactive-tutorial",
        "slug": "nonprofit-admin-getting-your-team-on-dropbox"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-how-do-i-set-up-admin-access-for-others",
        "slug": "nonprofit-admin-advanced-team-management"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-what-can-i-do-to-make-my-teams-account-even-more-secure",
        "slug": "nonprofit-admin-advanced-team-management"
      }
    },
    {
      "params": {
        "topicslug": "nonprofit-advanced-features-of-the-admin-console",
        "slug": "nonprofit-admin-advanced-team-management"
      }
    },
    {
      "params": {
        "topicslug": "microsoft-co-authoring-for-dropbox-guide",
        "slug": "microsoft-co-authoring-for-dropbox-course"
      }
    },
    {
      "params": {
        "topicslug": "get-started",
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "topicslug": "plan-and-configure",
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "topicslug": "deploy-and-empower-your-team",
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "topicslug": "manage-and-optimize",
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "topicslug": "additional-resources",
        "slug": "admin-deployment-guide"
      }
    },
    {
      "params": {
        "topicslug": "dash-admin-getting-started-guide",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "connect-and-manage-apps-as-an-admin",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "get-more-from-dash-using-the-browser-extension",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "ask-and-write-with-dash",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "search-and-find-answers",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "dash-for-admins-build-better-workspaces-with-stacks",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "dash-prompts",
        "slug": "dropbox-dash-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "dash-team-member-getting-started-guide",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "connect-and-manage-apps-as-a-team-member",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "get-more-from-dash-using-the-browser-extension",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "ask-and-write-with-dash",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "search-and-find-answers",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "build-better-workspaces-with-stacks",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "dash-prompts",
        "slug": "dropbox-dash-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-set-up-focus-time",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-use-habits",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-enable-calendar-sync",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-use-tasks",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-use-priorities",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-add-buffers-decompression-and-travel-time",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-use-smart-meetings",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "reclaim-how-to-set-up-scheduling-links",
        "slug": "reclaim-fundamentals-course"
      }
    },
    {
      "params": {
        "topicslug": "get-to-know-dash-in-dropbox",
        "slug": "dash-in-dropbox-admins"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-dash-in-dropbox",
        "slug": "dash-in-dropbox-team-members"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-dropbox-protect",
        "slug": "dropbox-protect-fundamentals"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-dropbox-sign",
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "sending-signature-requests",
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "dropbox-sign-templates",
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "bulk-send-signature-requests",
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "secure-signature-requests",
        "slug": "dropbox-sign-team-member-course"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-dropbox-sign-admin-console",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "manage-users-and-teams",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "configure-organization-settings",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "security-and-access-controls",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "monitor-activity-and-compliance",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "advanced-admin-features",
        "slug": "dropbox-sign-admin-course"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-the-dropbox-sign-api",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "manage-api-keys",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "monitor-api-activity",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "manage-api-apps",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "manage-callbacks",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "production-deployment",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "api-administration-best-practices",
        "slug": "dropbox-sign-api-course"
      }
    },
    {
      "params": {
        "topicslug": "use-dropbox-with-claude",
        "slug": "dropbox-ai-integrations"
      }
    },
    {
      "params": {
        "topicslug": "use-dropbox-with-chatgpt",
        "slug": "dropbox-ai-integrations"
      }
    },
    {
      "params": {
        "topicslug": "get-started-with-new-dropbox-experience",
        "slug": "new-dropbox-experience"
      }
    },
    {
      "params": {
        "topicslug": "manage-new-dropbox-experience",
        "slug": "new-dropbox-experience"
      }
    }
  ]
};